import React from 'react';
import { Instagram, Linkedin, Mail } from 'lucide-react';
import Card3D from '../ui/Card3D';
import { TeamMember } from '../../types/team';

interface TeamMemberCardProps {
  member: TeamMember;
}

const TeamMemberCard: React.FC<TeamMemberCardProps> = ({ member }) => {
  return (
    <Card3D>
      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
        <img 
          src={member.image} 
          alt={member.name}
          className="w-full h-64 object-cover"
        />
        <div className="p-6">
          <h3 className="text-xl font-bold mb-1" style={{ color: member.color }}>
            {member.name}
          </h3>
          <p className="text-gray-600 font-medium mb-2">{member.role}</p>
          <p className="text-gray-500 text-sm mb-4">{member.description}</p>
          <div className="flex space-x-4">
            <a href={member.linkedin} className="text-gray-400 hover:text-gray-600 transition-colors">
              <Linkedin className="w-5 h-5" />
            </a>
            <a href={member.instagram} className="text-gray-400 hover:text-gray-600 transition-colors">
              <Instagram className="w-5 h-5" />
            </a>
            <a href={member.mail} className="text-gray-400 hover:text-gray-600 transition-colors">
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>
      </div>
    </Card3D>
  );
};

export default TeamMemberCard;